import { styled } from '@mui/material/styles';
import React, { useContext } from 'react';
import { TenantContext } from 'shared/contexts';

export default function TenantLogoMark() {
    const { tenant } = useContext(TenantContext);

    if (!tenant?.logoMarkUri) {
        return null;
    }

    return (
        <Logo src={ tenant.logoMarkUri }
            alt="logo" />
    );
}

const Logo = styled('img')(({ theme }) => ({
    height: 32,
    width: 'auto',
  
    [theme.breakpoints.down('sm')]: {
        height: 28
    }
}));
